import { render, staticRenderFns } from "./PaginationNew.vue?vue&type=template&id=7e4b6d52&scoped=true"
import script from "./PaginationNew.vue?vue&type=script&lang=ts"
export * from "./PaginationNew.vue?vue&type=script&lang=ts"
import style0 from "./PaginationNew.vue?vue&type=style&index=0&id=7e4b6d52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4b6d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4b6d52')) {
      api.createRecord('7e4b6d52', component.options)
    } else {
      api.reload('7e4b6d52', component.options)
    }
    module.hot.accept("./PaginationNew.vue?vue&type=template&id=7e4b6d52&scoped=true", function () {
      api.rerender('7e4b6d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/PaginationNew.vue"
export default component.exports